<!--  -->
<template>
  <div></div>
</template>

<script>
export default {
  data () {
    return {
    };
  },
  created(){
      this.getOrderStatus()
      console.log('创建的标识='+localStorage.onlyCode)
        console.log('成功的标识='+localStorage.successCode)
        console.log(localStorage.takeOrderId)
  },
  methods: {
      // 获取订单状态
        getOrderStatus(){
            this.getShopInfo()
            if(localStorage.onlyCode){
                if(localStorage.onlyCode==localStorage.successCode && localStorage.takeOrderId!==undefined){
                    this.$router.push('/TakeCartDetail');
                }else{
                    this.$router.push('/TakeDishes');
                }
            }else{
                this.getCode();
            }
            
        },
        //获取店铺信息
        getShopInfo(){
            this.$axios({
                method:'get',
                headers: {
                    'code':sessionStorage.code,
                },
                url:this.$build+'/api/store/'+sessionStorage.storeId+'/customerShow',
            }).then(res =>{
                console.log(res);
                if(res.data.status==200){
                    // this.shopInfos=res.data.data;
                    sessionStorage.setItem('currency',res.data.data.currency.unit);
                    sessionStorage.setItem('is_quick',res.data.data.is_quick);
                }else{
                    this.$toast.allowMultiple();
                    for (var item in res.data.error) {
                        this.$toast({
                            type:'fail',
                            message:res.data.error[item],
                        });
                    }
                }
            }).catch(err =>{
                this.$toast({
                    type:'fail',
                    message:this.$t('common.message'),
                });
            });
        },
         getCode(){
            this.$axios({
                method:'get',
                url:this.$build+'/api/shopcart/create',
            }).then(res=>{
                console.log(res)
                if(res.data.status==200){
                    localStorage.setItem('onlyCode',res.data.code)
                    this.$router.push('/TakeDishes')
                }else{
                    for (var item in res.data.error) {
                        this.$toast({
                            type:'fail',
                            message:res.data.error[item],
                        });
                    }
                }
            }).catch(err => {
                this.$toast({
                    type:'fail',
                    message:this.$t('common.message'),
                });
            });
        },
  }
}

</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/takeAway/OrderStatus.vue